import { render } from "./UploadLogoComponent.vue?vue&type=template&id=ffa13478&scoped=true"
import script from "./UploadLogoComponent.vue?vue&type=script&lang=js"
export * from "./UploadLogoComponent.vue?vue&type=script&lang=js"

import "./UploadLogoComponent.vue?vue&type=style&index=0&id=ffa13478&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa13478"]])

export default __exports__